import { isEmpty } from 'lodash';
import { DiamondLogo, LogoColors } from 'ui/logo';
import { ThumbnailWrapper } from './Styled';

type ThumbnailProps = {
  thumbnailSrc: string;
};

export const Thumbnail = ({ thumbnailSrc }: ThumbnailProps) => {
  const isThumbnailAvailable = !isEmpty(thumbnailSrc);

  return (
    <ThumbnailWrapper isThumbnailAvailable={isThumbnailAvailable}>
      {isThumbnailAvailable ? (
        <img src={thumbnailSrc} />
      ) : (
        <DiamondLogo height={24} color={LogoColors.WHITE} />
      )}
    </ThumbnailWrapper>
  );
};
